export default "__VITE_ASSET__DGlGl1N1__"